import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const RepublicSeedrsLogoIcon = (props: IconProps) => (
  <ChakraIcon
    xmlns="http://www.w3.org/2000/svg"
    width="153"
    height="26"
    fill="none"
    {...props}
    viewBox="0 0 153 26"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M93.457 1.992v3.025c-.957-.676-1.816-1.014-2.581-1.014-.826 0-1.5.289-2.023.864-.523.547-.785 1.277-.785 2.189 0 .805.186 1.496.558 2.07.191.308.505.706.945 1.192a41.424 41.424 0 001.696 1.758c1.279 1.28 2.15 2.388 2.61 3.322.463.904.693 2.01.693 3.322 0 1.777-.505 3.243-1.52 4.393-1.018 1.122-2.32 1.684-3.909 1.684-1.338 0-2.48-.363-3.426-1.089v-3.067c1.116.804 2.132 1.207 3.048 1.207.856 0 1.523-.282 2.006-.841.485-.561.726-1.325.726-2.287 0-.833-.187-1.584-.559-2.249a9.122 9.122 0 00-.802-1.096 19.328 19.328 0 00-1.281-1.378 37.447 37.447 0 01-1.976-2.055c-.524-.596-.91-1.118-1.162-1.565-.484-.872-.725-1.975-.725-3.305 0-1.798.472-3.223 1.42-4.276.956-1.062 2.235-1.593 3.847-1.593 1.116 0 2.183.263 3.2.789zm3.01-.477h8.344v2.623h-5.206v7.283h4.618v2.622h-4.618v7.848h5.206v2.621h-8.344V1.515zm10.667 0h8.345v2.623h-5.207v7.283h4.619v2.622h-4.619v7.848h5.207v2.621h-8.345V1.515zm13.526 20.288c1.91 0 3.188-.571 3.833-1.714.664-1.141.996-3.36.996-6.657 0-3.546-.318-5.985-.95-7.314-.635-1.33-1.796-1.995-3.486-1.995h-.393v17.68zm-3.14-20.288h3.864c1.177 0 2.168.13 2.975.388.742.248 1.406.69 1.99 1.325.875.954 1.498 2.196 1.873 3.724.371 1.48.557 3.6.557 6.36 0 2.534-.206 4.599-.62 6.197-.401 1.53-1.066 2.695-1.99 3.5-1.139 1.002-3.176 1.503-6.111 1.503h-2.538V1.515zm16.867 10.189c1.217 0 2.079-.277 2.581-.834.503-.555.755-1.495.755-2.816 0-.714-.052-1.325-.16-1.833-.105-.505-.272-.917-.497-1.234a2.006 2.006 0 00-.875-.701c-.357-.148-.782-.223-1.276-.223h-.528v7.641zm-3.138-10.19h4.134c1.709 0 2.982.404 3.818 1.208 1.057 1.043 1.585 2.637 1.585 4.78 0 1.65-.28 2.973-.837 3.971-.559.998-1.357 1.616-2.392 1.853l4.286 11.186h-3.185l-4.271-11.26v11.26h-3.138V1.515zm20.048.478v3.025c-.956-.676-1.815-1.014-2.58-1.014-.826 0-1.5.289-2.024.864-.522.547-.784 1.277-.784 2.189 0 .805.187 1.496.559 2.07.19.308.505.706.942 1.192a41.397 41.397 0 001.699 1.758c1.277 1.28 2.148 2.388 2.61 3.322.462.904.695 2.01.695 3.322 0 1.777-.51 3.243-1.523 4.393-1.017 1.122-2.322 1.684-3.911 1.684-1.337 0-2.479-.363-3.425-1.089v-3.067c1.117.804 2.134 1.207 3.048 1.207.856 0 1.525-.282 2.009-.841.482-.561.723-1.325.723-2.287 0-.833-.187-1.584-.558-2.249a9.19 9.19 0 00-.8-1.096 19.988 19.988 0 00-1.284-1.378 37.686 37.686 0 01-1.976-2.055c-.524-.596-.91-1.118-1.162-1.565-.483-.872-.725-1.975-.725-3.305 0-1.798.474-3.223 1.418-4.276.957-1.062 2.239-1.593 3.85-1.593 1.116 0 2.182.263 3.199.789z"
      fill="#20292E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M54.912 9.533c3.404-3.358 17.44-5.578 18.633-5.762-5.147-5.04-13.46-5.029-18.59.037a12.871 12.871 0 00-1.283 16.897 8.898 8.898 0 011.24-11.172z"
      fill="#BCD672"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M73.622 3.847c-.186 1.177-2.433 15.034-5.836 18.392-3.076 3.037-7.802 3.44-11.323 1.223 5.157 3.758 12.453 3.347 17.123-1.262a12.884 12.884 0 00.036-18.353z"
      fill="#6B8F3E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M69.42 18.162c-2.743 2.707-7.286 2.608-10.152-.22-2.866-2.828-2.966-7.315-.224-10.022.64-.632 1.786-1.2 3.161-1.699-3.113.904-5.987 2.024-7.293 3.312a8.905 8.905 0 000 12.706c3.556 3.51 9.319 3.51 12.874 0 1.305-1.288 2.439-4.121 3.353-7.19-.504 1.353-1.078 2.481-1.719 3.113z"
      fill="#8AC144"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.759 26V0h.896v26h-.896z"
      fill="#DFE3E8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.397 15.381L23.27 26H0V0h12.236c.424 0 .812.016 1.169.048a7.902 7.902 0 011.992 15.333z"
      fill="#157EFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.155 26H0V0l23.109 26h-7.954z"
      fill="#157EFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.27 26H.001L11.555 7.843 23.27 26z"
      fill="#00BDFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 15.045V0h6.494l9.704 15.044L0 15.045z"
      fill="#1560FA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.972 15.048l4.582-7.205 4.647 7.205h-9.23z"
      fill="#00EFE9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.27 26h-8.645l-3.07-18.157L23.27 26z"
      fill="#157EFF"
      fillOpacity=".5"
    />
  </ChakraIcon>
);
